import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import clsx from "clsx";
import StandardModal from "@/js/components/shared/StandardModal";
import useStore, { ClasswizeState } from "@/stores/index";

const DisplayNameModal: FC = () => {
	const [displayName, setDisplayName] = useState(localStorage.getItem("USERNAME") as string);

	const {
		data,
		errorMsg: displayNameErrorMsg,
		error: hasDisplayNameError,
		isSubmittingDisplayName: disableDisplayNameInput,
	} = useStore(({ chat }: ClasswizeState) => chat.displayName);

	const showDisplayNameModal = useStore((state: ClasswizeState) => state.chat.showDisplayNameModal);

	useEffect(() => {
		setDisplayName(data);
	}, [data, showDisplayNameModal]);

	const handleDisplayNameUpdate = (evt: ChangeEvent<HTMLInputElement>) => {
		setDisplayName(evt.target.value);
	};

	const submitDisplayName = useStore((state: ClasswizeState) => state.chat.submitDisplayName);
	const toggleDisplayNameModal = useStore((state: ClasswizeState) => state.chat.toggleDisplayNameModal);

	const handleSubmitDisplayName = (evt: FormEvent<HTMLFormElement>) =>
		void (async () => {
			evt.preventDefault();
			if (disableDisplayNameInput) {
				return;
			}

			const submission = await submitDisplayName(displayName);

			if (submission) {
				toggleDisplayNameModal(false, true);
			}
		})();

	const handleDisplayNameModalClose = () => {
		toggleDisplayNameModal(false, true);
	};

	const launchedFromChatSettings = useStore((state: ClasswizeState) => state.chat.launchedFromChatSettings);

	const title = launchedFromChatSettings ? "Chat Settings" : "Set your username";

	const description = launchedFromChatSettings
		? "Please contact your school’s IT support team if you require additional changes."
		: "This will be the name that students see when you message them.";

	return (
		<StandardModal
			size="medium"
			contentClassName="ChatDisplaynameModal_content"
			header={<div className="ChatDisplaynameModal_title">{title}</div>}
			open={showDisplayNameModal}
			close={handleDisplayNameModalClose}
		>
			<div className="ChatDisplaynameModal_subtitle">{description}</div>
			<form onSubmit={handleSubmitDisplayName}>
				<div className="ChatDisplaynameModal_description">
					<label className="block-label">
						<strong>Chat username (visible to students)</strong>
					</label>
					<input
						className={clsx("form-input", {
							"input-error": hasDisplayNameError,
						})}
						onChange={handleDisplayNameUpdate}
						placeholder="Enter Display Name"
						type="text"
						value={displayName}
						disabled={disableDisplayNameInput}
					/>
					{hasDisplayNameError && (
						<div className="error">{displayNameErrorMsg || "Could not save your display name, please try again later."}</div>
					)}
				</div>
				<button className="button-callToAction--normal button-fullwidth">Save</button>
			</form>
		</StandardModal>
	);
};

export default DisplayNameModal;
